import abusedToken from "../abis/development/tokens/abusedToken";

export default {
  name: "ABUSD",
  abi: abusedToken.abi,
  contractAddress: "0x0dA7acf3c800797CeAbcA1F3ff7ba99664fE0245",
  decimals: 9,
};
